const fileExtensionMap = new Map([['docx', 'Microsoft Word']]);
export const getFileExtensionName = (extension) => {
    if (extension && extension.toLowerCase().trim() !== '') {
        return fileExtensionMap.get(extension) || `.${extension}`;
    }
    return null;
};
